import React, {useEffect, useState} from 'react'
import {Route, Redirect, useHistory} from 'react-router-dom'
import {connect} from 'react-redux'
import ClientLayout from 'layouts/Client'
import { fetchDetailsSubscription } from "redux/Payments/PaymentsActions";
import { useDispatch } from "react-redux";
import { getSpecialtyFields } from "config/subscriptionPlans";
import Swal from 'sweetalert2';
import jwtDecode from 'jwt-decode';
const  ClientRoute = ({component:Component, authenticated, admin, authChecked, loading, userDetails,updateUserProfile, activeSpecialty, ...rest}) => {

    const dispatch = useDispatch()
    const history = useHistory();
    const fields = getSpecialtyFields(activeSpecialty);

    useEffect(() => {
        if(Object.keys(userDetails).length){
            if(typeof userDetails[fields.subsId] != "undefined"){
                dispatch(fetchDetailsSubscription({ subsId : userDetails[fields.subsId] }))
            }
        }

    }, [userDetails, activeSpecialty])


    const isValidUSE164 = (s) => /^\+1[2-9]\d{2}[2-9]\d{6}$/.test(s);

    const isValidUSNumber = (input) => {
        const d = (input || "").replace(/\D/g, "");

        const e164 =
            d.length === 10 ? `+1${d}` :
                (d.length === 11 && d.startsWith("1") ? `+${d}` : null);
        return e164 ? isValidUSE164(e164) : false;
    };

    // useEffect(() => {

    //     if (authenticated) {

    //         const phoneNumber = updateUserProfile.userprofile?.[0]?.phoneNumber ? updateUserProfile.userprofile?.[0]?.phoneNumber : userDetails.phoneNumber;

    //         if (!isValidUSNumber(phoneNumber)) {
    //             setTimeout(() => {
    //                 Swal.fire({
    //                     title: 'Phone Number',
    //                     text: "Enter a valid 10-digit U.S. phone number.",
    //                     icon: 'warning',
    //                     showCancelButton: true,
    //                     confirmButtonColor: '#5e72e4',
    //                     confirmButtonText: 'Go to My Profile',
    //                     cancelButtonText: 'Close',
    //                     allowOutsideClick: true
    //                 }).then((result) => {
    //                     if(result.isConfirmed){
    //                         if (history.location.pathname != "/client/my-profile") {
    //                             history.push("/client/my-profile")
    //                         }
    //                     }
    //                 });
    //             }, 5000);
    //         }

    //     }

    // }, [history.location.pathname])

    // Manage loading Swal via useEffect — avoids race condition where
    // Swal.isVisible() returns false because the open animation hasn't finished
    useEffect(() => {
        if (!authChecked || loading) {
            Swal.fire({
                title: 'Loading...',
                text: 'Please wait while loading',
                allowOutsideClick: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });
        } else {
            Swal.close();
        }
    }, [authChecked, loading]);

    return (
        <Route {...rest}
            render = {(props) => {
                if (!authChecked || loading) {
                    return null;
                }

                // Check if token is actually valid
                const token = localStorage.getItem('FBIdToken');
                let tokenValid = false;
                if (token) {
                    try {
                        const decoded = jwtDecode(token);
                        tokenValid = decoded.exp * 1000 > Date.now();
                    } catch (e) {
                        tokenValid = false;
                    }
                }

                if (authenticated == true && tokenValid){
                    if (admin == true ){

                        return <Redirect to = "/admin/question-bank"/>
                    } else {

                        return <ClientLayout><Component {...props}/></ClientLayout>

                    }
                } else {
                    return <Redirect to = "/auth/login"/>
                }
            }
            }
        />
    )}
const mapStateToProps = (state) => ({
    authenticated: state.loginAuth.authenticated,
    admin: state.loginAuth.admin,
    authChecked: state.loginAuth.authChecked,
    loading: state.loginAuth.loading,
    userDetails : state.loginAuth.userDetails,
    updateUserProfile: state.updateUserProfile,
    activeSpecialty: state.specialty?.activeSpecialty || 'pmr',
})


export default connect(mapStateToProps)(ClientRoute)
